import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AdvancePayments  {
    _originalTypeClassName = "zERP.BO.AdvancePayments";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AdvancePayments.translate = translateService;
}
this.MultiDeduction = [];
this.Id = null;
this.Document_Id = null;
this.Notes = null;
this.Status = null;
this.DeductionLEDE = false;
this.CourtAssumption = null;
this.Representative = null;
this.ContractNumber = null;
this.WithdrawalDecisionNumber = null;
this.ProtocolReceiptDate = null;
this.ProtocolReceiptNumber = null;
this.InvoiceDate = null;
this.InvoiceNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Document_Id:any;
Notes:any;
Status:any;
DeductionLEDE:any;
CourtAssumption:any;
Representative:any;
ContractNumber:any;
WithdrawalDecisionNumber:any;
ProtocolReceiptDate:any;
ProtocolReceiptNumber:any;
InvoiceDate:any;
InvoiceNumber:any;
CurrentLawyerFirm:any;
JudicialYear:any;
MultiDeduction:any;
static setCurrentLawyerFirm = ($this, value) => {
var oldValue = $this.CurrentLawyerFirm;
$this.CurrentLawyerFirm = value;
if (value != null) {
}
}
static setJudicialYear = ($this, value) => {
var oldValue = $this.JudicialYear;
$this.JudicialYear = value;
if (value != null) {
}
}
static setMultiDeduction = ($this, items) => {
                if (items == null) items = [];
                if ($this.MultiDeduction == null) $this.MultiDeduction = [];

                const copyItems = Common.cloneObject(items);

                while ($this.MultiDeduction.length > 0) {
                    Domain.AdvancePayments.removeMultiDeduction($this, $this.MultiDeduction[0]);
                }

                Domain.AdvancePayments.addManyMultiDeduction($this, copyItems);
            }
static addManyMultiDeduction = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AdvancePayments.addMultiDeduction($this, items[i]);
                }
            }
static addMultiDeduction = ($this, item) => {
                if ($this.MultiDeduction == null) $this.MultiDeduction = [];
                if (item == null || $this.MultiDeduction.indexOf(item) > -1) return;
                $this.MultiDeduction.push(item);
}
static addRangeMultiDeduction = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AdvancePayments.addMultiDeduction($this, item));
            }
static removeMultiDeduction = ($this, item) => {
                if ($this == null || $this.MultiDeduction == null || $this.MultiDeduction.indexOf(item) === -1) return;
                var _index = $this.MultiDeduction.indexOf(item);
                $this.MultiDeduction.splice(_index, 1);
}
static clearMultiDeduction = ($this) => { $this.MultiDeduction = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}